import React from 'react';
import styles from '../Tabs/UserManager.module.scss';

const UserRow = ({ user, onDelete }) => {
  return (
    <div className={styles.row}>
      <h4>{user.email}</h4>
      <h4 onClick={(e) => onDelete(e, user.email)}>
        Delete
      </h4>
    </div>
  );
};

export default UserRow;
